clearYasguiDefaults()

export const localModeIsActive: boolean = process.env.REACT_APP_LOCAL_MODE
  ? JSON.parse(process.env.REACT_APP_LOCAL_MODE)
  : false

export function saveConfigLocal(viewer: unknown) {
  localStorage.setItem('WISTOR_LOCAL_MODE_CONFIG', JSON.stringify(viewer))
}

export function loadConfigLocal() {
  const viewerStr = localStorage.getItem('WISTOR_LOCAL_MODE_CONFIG')
  const viewer = viewerStr?.length ? JSON.parse(viewerStr) : null
  if (!viewer) return getDefaultConfig()
  return viewer
}

/**
 * Just removing everything for now, instead of only removing the endpoint.
 * Not worth the time at time of authoring.
 */
function clearYasguiDefaults() {
  for (const key of ['yagui__config', 'prefixes']) localStorage.removeItem(key)
}

function getDefaultConfig() {
  return {
    "title": "Kadaster KKG demonstrator",
    "subtitle": "",
    "mainArea": {
      "direction": "column",
      "areaSizes": [
        "30%",
        "70%"
      ],
      "areas": [
        {
          "direction": "column",
          "areaSizes": [
            "30%",
            "70%"
          ],
          "areas": [
            {
              "areaSizes": [
                "1",
                "1",
                "1",
                "1"
              ],
              "areas": [
                {
                  "publishVariable": "provincie",
                  "height": "100%",
                  "query": "prefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\n\n\nselect distinct ?uri ?geometry ?color (?color as ?label)\n#noLegend;\n#minimal;\n\nwhere\n{\n \n          ?uri a imx:Provincie.\n          ?uri geo:hasGeometry/geo:asWKT ?geometry.\n        #  ?uri rdfs:label ?color.\n    ?uri imx:naam ?color\n\n     \n}\nlimit 12\n\n#title: Provincie;\n#baselayer:PDOK grijs;\n \n\n",
                  "showLoadingOverlay": true,
                  "syncWithUserActionsDisabled": true,
                  "voteForUserActionsDisabledWhenLoading": true,
                  "widget": "BBMap",
                  "panelstyle": "paper2",
                  "titleMenubar": "Provincies",
                  "infoMenubar": "selecteer een provincie",
                  "startWithBase": "PDOK grijs"
                },
                {
                  "startWithBase": "PDOK grijs",
                  "infoMenubar": "Selecteer een gemeente",
                  "titleMenubar": "Gemeenten",
                  "widget": "BBMap",
                  "voteForUserActionsDisabledWhenLoading": true,
                  "syncWithUserActionsDisabled": true,
                  "showLoadingOverlay": true,
                  "query": "prefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\n\n#noLegend;\n#minimal;\nselect distinct ?uri ?geometry ?color (?color as ?label)\nwhere\n{\n          ?uri geo:sfWithin <{{provincie}}>.\n          ?uri a imx:Gemeentegebied.\n          ?uri geo:hasGeometry/geo:asWKT ?geometry.\n         # ?uri rdfs:label ?color.\n        ?uri imx:naam ?color\n     \n}\n\n#baselayer:PDOK grijs;\n#title: Gemeente;\n\n \n\n",
                  "panelstyle": "paper2",
                  "publishVariable": "gemeente"
                },
                {
                  "infoMenubar": "selecteer een Wijk",
                  "titleMenubar": "Wijk",
                  "widget": "BBMap",
                  "voteForUserActionsDisabledWhenLoading": true,
                  "syncWithUserActionsDisabled": true,
                  "showLoadingOverlay": true,
                  "query": "prefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\n\n#noLegend;\n#minimal;\n#baselayer:PDOK grijs;\nselect distinct ?uri ?geometry ?color (?color as ?label)\nwhere\n{\n          ?uri geo:sfWithin <{{gemeente}}>.\n          ?uri a imx:Wijk.\n          ?uri geo:hasGeometry/geo:asWKT ?geometry.\n          ?uri imx:naam ?color\n     \n}\n\n\n#title: Wijk;\n\n \n\n",
                  "panelstyle": "paper2",
                  "publishVariable": "wijk",
                  "startWithGreyBase": true,
                  "startWithBase": "PDOK grijs"
                },
                {
                  "startWithBase": "PDOK grijs",
                  "publishVariable": "buurt",
                  "panelstyle": "paper2",
                  "query": "prefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\n\n#noLegend;\n#minimal;\n#baselayer:PDOK grijs;\nselect distinct ?uri ?geometry ?color (?color as ?label)\nwhere\n{\n          ?uri geo:sfWithin <{{wijk}}>.\n          ?uri a imx:Buurt.\n          ?uri geo:hasGeometry/geo:asWKT ?geometry.\n         # ?uri rdfs:label ?color.\n        ?uri imx:naam ?color\n     \n}\n\n\n#title: Buurt;\n\n \n\n",
                  "showLoadingOverlay": true,
                  "syncWithUserActionsDisabled": true,
                  "voteForUserActionsDisabledWhenLoading": true,
                  "widget": "BBMap",
                  "titleMenubar": "Buurt",
                  "infoMenubar": "selecteer een Buurt"
                }
              ],
              "direction": "row",
              "widget": "SplitLayout"
            },
            {
              "widget": "SplitLayout",
              "direction": "row",
              "areas": [
                {
                  "areaSizes": [
                    "90px",
                    "auto",
                    "auto"
                  ],
                  "areas": [
                    {
                      "infoMenubar": "CBS gegevens van de geselecteerde gemeente,wijk of buurt",
                      "titleMenubar": "CBS data",
                      "panelstyle": "paper2",
                      "widget": "RadioBox",
                      "voteForUserActionsDisabledWhenLoading": true,
                      "syncWithUserActionsDisabled": true,
                      "showLoadingOverlay": true,
                      "options": "buurt,buurt,wijk,wijk,gemeente,gemeente",
                      "horizontal": true,
                      "publishVariable": "keuze"
                    },
                    {
                      "panelstyleExtra": "noScrollBars",
                      "popupLabelFixedFormat": "2",
                      "labelsInChart": false,
                      "width": "95%",
                      "charttype": "Bar",
                      "widget": "BBEChart",
                      "voteForUserActionsDisabledWhenLoading": true,
                      "syncWithUserActionsDisabled": true,
                      "showLoadingOverlay": true,
                      "query": "prefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\nprefix imx-ext: <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#>\n\n\nselect distinct ?property ?value\nwhere\n{\n  { ?obj imx-ext:regio <{{buurt}}> .filter (\"{{keuze}}\"=\"buurt\")}\n  union\n  { ?obj imx-ext:regio <{{wijk}}> .filter (\"{{keuze}}\"=\"wijk\")}\n  union\n  { ?obj imx-ext:regio <{{gemeente}}> .filter (\"{{keuze}}\"=\"gemeente\")}\n        \n \n          ?obj ?pred ?value.\n            filter (ISLITERAL(?value))\n            bind (STRAFTER(STR(?pred),\"#\") as ?property1)\n            filter (?value!=\"-99999999\")\n            filter (strstarts(?property1,\"aantal_bedrijven_\"))\n             bind (replace(?property1,\"aantal_bedrijven_\",\"\") as ?property)\n\n}\n\n\n\n \n\n",
                      "panelstyle": "paper2",
                      "gradientColors": true,
                      "enableZoom": false,
                      "stringToColor": true,
                      "defaultMenu": false,
                      "legend": false,
                      "height": "90%",
                      "titleMenubar": "Industrie"
                    },
                    {
                      "enableZoom": true,
                      "gradientColors": true,
                      "stringToColor": true,
                      "charttype": "Bar",
                      "query": "prefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\nprefix imx-ext: <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#>\n\nselect distinct ?property ?value\nwhere\n{ \n  { ?obj imx-ext:regio <{{buurt}}> .filter (\"{{keuze}}\"=\"buurt\")}\n  union\n  { ?obj imx-ext:regio <{{wijk}}> .filter (\"{{keuze}}\"=\"wijk\")}\n  union\n  { ?obj imx-ext:regio <{{gemeente}}> .filter (\"{{keuze}}\"=\"gemeente\")}\n          ?obj ?pred ?value.\n            filter (ISLITERAL(?value))\n            bind (STRAFTER(STR(?pred),\"#\") as ?property1)\n            filter (?value!=\"-99999999\")\n            filter (strstarts(?property1,\"percentage_personen_\"))\n            bind (replace(?property1,\"percentage_personen_\",\"\") as ?property)\n\n  \n}\n\n\n\n \n\n",
                      "showLoadingOverlay": true,
                      "syncWithUserActionsDisabled": true,
                      "voteForUserActionsDisabledWhenLoading": true,
                      "widget": "BBEChart",
                      "panelstyle": "paper2",
                      "panelstyleExtra": "noScrollBars",
                      "titleMenubar": "Leeftijden"
                    }
                  ],
                  "direction": "column",
                  "widget": "SplitLayout"
                },
                {
                  "startWithGreyBase": true,
                  "publishVariable": "selection",
                  "panelstyle": "paper2",
                  "widget": "Tab",
                  "voteForUserActionsDisabledWhenLoading": true,
                  "syncWithUserActionsDisabled": true,
                  "showLoadingOverlay": true,
                  "query": "PREFIX igeo: <http://rdf.insee.fr/def/geo#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX im: <http://imgpedia.dcc.uchile.cl/resource/>\nprefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\nprefix imx-ext: <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#>\n\n\nselect ?uri ?geometry ?color ?label\n#baselayer:PDOK grijs;\nwhere\n{\n{\n  <{{buurt}}> imx:bevatPerceel ?uri .     \n  ?uri geo:hasGeometry/geo:asWKT ?geometry.\n  ?uri imx-ext:perceelnummer ?label.\n    \n  bind (\"Perceel\" as ?color)\n\n    }\n\n        union\n        {\n  \n   <{{buurt}}> imx:bevatPerceel/^imx:bevindtZichOpPerceel ?uri.\n    bind (strbefore(strafter(str(?uri),\"/id/\"),\"/\")  as ?color2)\n    optional {?uri imx:type ?color3}\n    bind (coalesce(?color3,?color2) as ?color)\n   \n    {?uri imx-ext:maaiveldgeometrie/geo:asWKT ?geometrymv. \n   optional {\n  ?uri imx-ext:bovenaanzichtgeometrie/geo:asWKT ?geometrybo }\n    bind (coalesce (?geometrybo,?geometrymv) as ?geometry)\n  }\n    \n    union {\n    \n  ?uri geo:hasGeometry/geo:asWKT ?geometry }\n  }\n  \n      \n     \n}\n\n\n#title: Objecten in de Buurt;\n#color:RGBA(175,175,175,1)@\"Perceel\"\n#color:RGBA(175,0,0,1)@\"kunstwerkdeel\"\n \n\n",
                  "titleMenubar": "",
                  "infoMenubar": "",
                  "tabs": [
                    "IMX-Geo",
                    "Gebouwtypes"
                  ],
                  "areas": [
                    {
                      "startWithGreyBase": true,
                      "publishVariable": "selection",
                      "panelstyle": "paper2",
                      "widget": "BBMap",
                      "voteForUserActionsDisabledWhenLoading": true,
                      "syncWithUserActionsDisabled": true,
                      "showLoadingOverlay": true,
                      "query": "PREFIX igeo: <http://rdf.insee.fr/def/geo#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX im: <http://imgpedia.dcc.uchile.cl/resource/>\nprefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\nprefix imx-ext: <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#>\n\n\nselect ?uri ?geometry ?color ?label\n#baselayer:PDOK grijs;\nwhere\n{\n{\n  <{{buurt}}> imx:bevatPerceel ?uri .  \n      ?uri imx:registratiegegevens ?reg.\n      filter not exists {?reg <https://modellen.geostandaarden.nl/def/imx-geo#eindGeldigheid> []}\n  ?uri geo:hasGeometry/geo:asWKT ?geometry.\n  ?uri imx-ext:perceelnummer ?label.\n    \n  bind (\"Perceel\" as ?color)\n\n    }\n\n        union\n        {\n  \n   <{{buurt}}> imx:bevatPerceel ?perceel. \n      ?perceel imx:registratiegegevens ?preg.\n      filter not exists {?preg <https://modellen.geostandaarden.nl/def/imx-geo#eindGeldigheid> []}\n    \n    \n    ?perceel ^imx:bevindtZichOpPerceel ?uri.\n      ?uri imx:registratiegegevens ?reg.\n      filter not exists {?reg <https://modellen.geostandaarden.nl/def/imx-geo#eindGeldigheid> []}\n    \n    bind (strbefore(strafter(str(?uri),\"/id/\"),\"/\")  as ?color2)\n    optional {?uri imx:type ?color3}\n    bind (coalesce(?color3,?color2) as ?color)\n   \n    {?uri imx-ext:maaiveldgeometrie/geo:asWKT ?geometrymv. \n   optional {\n  ?uri imx-ext:bovenaanzichtgeometrie/geo:asWKT ?geometrybo }\n    bind (coalesce (?geometrybo,?geometrymv) as ?geometry)\n  }\n    \n    union {\n    \n  ?uri geo:hasGeometry/geo:asWKT ?geometry }\n  }\n  \n      \n     \n}\n\n\n#title: Objecten in de Buurt;\n#color:RGBA(175,175,175,1)@\"Perceel\"\n#color:RGBA(175,0,0,1)@\"kunstwerkdeel\"\n    #minimal;\n \n\n",
                      "titleMenubar": "Buurt gegevens",
                      "infoMenubar": "Interactieve kaart. Selecteer een gebouw, bouwwerk of perceel",
                      "startWithBase": "PDOK grijs"
                    },
                    {
                      "titleMenubar": "Gebouw types",
                      "publishVariable": "selection",
                      "query": "PREFIX igeo: <http://rdf.insee.fr/def/geo#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX im: <http://imgpedia.dcc.uchile.cl/resource/>\nprefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\nprefix imx-ext: <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#>\n\n\nselect ?uri ?geometry ?color (?color as ?label)\n#baselayer:PDOK grijs;\nwhere\n{\n\n      \n  \n   <{{buurt}}> imx:bevatPerceel ?perceel.\n    ?perceel imx:registratiegegevens ?preg.\n      filter not exists {?preg <https://modellen.geostandaarden.nl/def/imx-geo#eindGeldigheid> []}\n   \n  ?perceel ^imx:bevindtZichOpPerceel ?uri.\n    ?uri imx:registratiegegevens ?reg.\n      filter not exists {?reg <https://modellen.geostandaarden.nl/def/imx-geo#eindGeldigheid> []}\n    bind (strbefore(strafter(str(?uri),\"/id/\"),\"/\")  as ?color2)\n    optional {?uri <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#gebouwType> ?color3}\n    bind (coalesce(?color3,?color2) as ?color)\n   \n    {?uri imx-ext:maaiveldgeometrie/geo:asWKT ?geometrymv. \n   optional {\n  ?uri imx-ext:bovenaanzichtgeometrie/geo:asWKT ?geometrybo }\n    bind (coalesce (?geometrybo,?geometrymv) as ?geometry)\n  }\n    \n      \n     \n}\n\n\n#title: Gebouwtypes in de Buurt;\n\n \n\n",
                      "showLoadingOverlay": true,
                      "syncWithUserActionsDisabled": true,
                      "voteForUserActionsDisabledWhenLoading": true,
                      "widget": "BBMap"
                    }
                  ],
                  "carouselClickNavigation": false,
                  "appearance": "CAROUSEL_WITH_BUTTONS"
                },
                {
                  "widget": "SplitLayout",
                  "direction": "column",
                  "areas": [
                    {
                      "infoMenubar": "adres gegevens van het geselecteerde object",
                      "widget": "Table",
                      "voteForUserActionsDisabledWhenLoading": true,
                      "syncWithUserActionsDisabled": true,
                      "showLoadingOverlay": true,
                      "query": "PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n\n\nselect distinct ?omschrijving\n\nwhere\n\n{\n\n  {?geb <http://modellen.geostandaarden.nl/def/imx-geo#bevindtZichOpPerceel> <{{selection}}>.}\n        union {\n        bind (<{{selection}}> as ?geb)}\n      ?geb <http://modellen.geostandaarden.nl/def/imx-geo#heeftAlsAdres>/<http://modellen.geostandaarden.nl/def/imx-geo#omschrijving> ?omschrijving.\n    \n  \n      \n\n\n}\n\n        limit 100",
                      "panelstyle": "paper2",
                      "titleMenubar": "Adressen"
                    },
                    {
                      "panelstyle": "paper2",
                      "query": "PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n\n\nselect distinct ?grondslag\n\nwhere\n\n{\n {\n    <{{selection}}> <http://modellen.geostandaarden.nl/def/imx-geo#bevindtZichOpPerceel> ?perceel  }\n     union \n    {\n        bind (<{{selection}}> as ?perceel)\n     }\n    \n  ?bep <http://modellen.geostandaarden.nl/def/imx-geo#isBeperkingOpPerceel>?perceel.\n  ?bep <http://modellen.geostandaarden.nl/def/imx-geo#grondslag> ?grondslag\n      \n\n\n}\n\n        limit 100",
                      "showLoadingOverlay": true,
                      "syncWithUserActionsDisabled": true,
                      "voteForUserActionsDisabledWhenLoading": true,
                      "widget": "Table",
                      "titleMenubar": "Beperking",
                      "infoMenubar": "evt beperkingen op het geselecteerde perceel of bouwwerk"
                    },
                    {
                      "infoMenubar": "Algemene kenmerken van het geselecteerd object",
                      "titleMenubar": "Kenmerken",
                      "panelstyle": "paper2",
                      "query": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\nprefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\nprefix imx-ext: <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#>\n\n\nselect distinct ?property ?value ?literal ?pred\nwhere\n{\n  \n  {\n     <{{selection}}> a/rdfs:label ?value.\n    bind (\"type\" as ?property)\n    bind (\"true\" as ?literal)\n    bind (rdf:type as ?pred)\n   \n  }\n  union\n  {\n     \n  <{{selection}}> ?pred ?value.\n    bind (STR(ISLITERAL(?value)) as ?literal)\n   # filter (?literal=true)\n            filter (?value!=\"-99999999\")\n  ?pred rdfs:label ?property.\n    optional {?pred rdfs:comment ?beschrijving}\n  filter (?property not in (\"domein\",\"identificatie\"))\n  \n # bind (coalesce(?label,?property2) as ?property)\n  }\n \n}\n  \n\n",
                      "showLoadingOverlay": true,
                      "syncWithUserActionsDisabled": true,
                      "voteForUserActionsDisabledWhenLoading": true,
                      "widget": "BBPropertyPanel",
                      "childParameterText": "{{selection}}"
                    }
                  ],
                  "areaSizes": [
                    "33%",
                    "33%",
                    "auto"
                  ]
                }
              ],
              "areaSizes": [
                "40%",
                "45%",
                "15%"
              ]
            }
          ],
          "widget": "SplitLayout"
        },
        {
          "widget": "SplitLayout",
          "direction": "column",
          "areas": [
            {
              "widget": "SearchAutocomplete",
              "voteForUserActionsDisabledWhenLoading": true,
              "syncWithUserActionsDisabled": true,
              "showLoadingOverlay": true,
              "query": "prefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\n\nselect distinct  ?label  ?uri \nwhere\n{\n        \n           ?uri a imx:Gemeentegebied.\n           ?uri imx:naam ?label.\n   \n}\n\n\n\n",
              "panelstyle": "paper2",
              "publishVariable": "gem",
              "textbefore": "Gemeente",
              "nullSelectionResetVariable": true,
              "alignItems": "flex-start",
              "placeholderText": "selecteer een gemeente"
            },
            {
              "areaSizes": [
                "50%",
                "50%"
              ],
              "areas": [
                {
                  "widget": "SplitLayout",
                  "direction": "column",
                  "areas": [
                    {
                      "basequery": "",
                      "infoMenubar": "selecteer een Wijk",
                      "titleMenubar": "Wijk",
                      "widget": "BBMap",
                      "voteForUserActionsDisabledWhenLoading": true,
                      "syncWithUserActionsDisabled": true,
                      "showLoadingOverlay": true,
                      "query": "PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nprefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\n\n#noLeffgend;\n#minimal;\n#baselayer:PDOK grijs;\nselect distinct ?uri ?geometry ?label  (xsd:float(count (distinct ?gebouw))  as ?color)\nwhere\n{\n     \n  ?uri geo:sfWithin <{{gem}}>.\n          ?uri a imx:Wijk.\n          ?uri geo:hasGeometry/geo:asWKT ?geometry.\n       \n          ?uri imx:naam ?label.\n       optional\n      { ?buurt geo:sfWithin ?uri.\n       ?buurt imx:bevatPerceel/^imx:bevindtZichOpPerceel ?gebouw.\n       ?gebouw <http://modellen.geostandaarden.nl/def/imx-geo#status> \"Sloopvergunning verleend\"\n     }\n     \n}\n   group by ?uri ?geometry ?label\n\n\n#title: Aantal sloop vergunningen;\n\n \n\n",
                      "panelstyle": "paper2",
                      "publishVariable": "wijk2",
                      "startWithGreyBase": true,
                      "startWithBase": "PDOK grijs"
                    },
                    {
                      "startWithBase": "PDOK grijs",
                      "startWithGreyBase": true,
                      "publishVariable": "buurt2",
                      "panelstyle": "paper2",
                      "query": "PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nprefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\n\n#noLefgend;\n#minimal;\n#baselayer:PDOK grijs;\nselect distinct ?uri ?geometry ?label (xsd:float(count (distinct ?gebouw) ) as ?color)\nwhere\n{\n  \n          ?uri geo:sfWithin <{{wijk2}}>.\n          ?uri a imx:Buurt.\n          ?uri geo:hasGeometry/geo:asWKT ?geometry.\n          ?uri imx:naam ?label.\n       optional\n      { \n       ?uri imx:bevatPerceel/^imx:bevindtZichOpPerceel ?gebouw.\n       ?gebouw <http://modellen.geostandaarden.nl/def/imx-geo#status> \"Sloopvergunning verleend\"\n     }\n     \n}\n      group by ?uri ?geometry ?label\n\n\n#title: Aantal sloop vergunningen;\n\n \n\n",
                      "showLoadingOverlay": true,
                      "syncWithUserActionsDisabled": true,
                      "voteForUserActionsDisabledWhenLoading": true,
                      "widget": "BBMap",
                      "titleMenubar": "aantal sloopvergunningen",
                      "infoMenubar": "selecteer een Wijk"
                    }
                  ],
                  "areaSizes": [
                    "1",
                    "1"
                  ]
                },
                {
                  "widget": "SplitLayout",
                  "direction": "column",
                  "areas": [
                    {
                      "startWithBase": "PDOK grijs",
                      "startWithGreyBase": true,
                      "publishVariable": "selection2",
                      "panelstyle": "paper2",
                      "widget": "BBMap",
                      "voteForUserActionsDisabledWhenLoading": true,
                      "syncWithUserActionsDisabled": true,
                      "showLoadingOverlay": true,
                      "query": "PREFIX igeo: <http://rdf.insee.fr/def/geo#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX im: <http://imgpedia.dcc.uchile.cl/resource/>\nprefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\nprefix imx-ext: <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#>\n\n\nselect ?uri ?geometry ?color (?color as ?label)\n#baselayer:PDOK grijs;\n\n#minimal;\nwhere\n{\n\n  \n   <{{buurt2}}> imx:bevatPerceel/^imx:bevindtZichOpPerceel ?uri.\n    bind (strbefore(strafter(str(?uri),\"/id/\"),\"/\")  as ?color2)\n    optional {?uri <http://modellen.geostandaarden.nl/def/imx-geo#status> ?color3.filter (?color3=\"Sloopvergunning verleend\")}\n    bind (coalesce(?color3,?color2) as ?color)\n   \n    ?uri imx-ext:maaiveldgeometrie/geo:asWKT ?geometrymv. \n#   optional {\n # ?uri imx-ext:bovenaanzichtgeometrie/geo:asWKT ?geometrybo }\n    bind (coalesce (?geometrybo,?geometrymv) as ?geometry)\n \n   \n  \n      \n     \n}\n\n\n#title: Objecten in de Buurt;\n#color:RGBA(175,175,175,1)@\"Perceel\"\n#color:RGBA(175,0,0,1)@\"kunstwerkdeel\"\n \n\n",
                      "titleMenubar": "Sloop vergunning",
                      "infoMenubar": "Interactieve kaart. Selecteer een gebouw, bouwwerk of perceel"
                    },
                    {
                      "panelstyleExtra": "noScrollBars",
                      "popupLabelFixedFormat": "2",
                      "labelsInChart": false,
                      "width": "95%",
                      "charttype": "Bar",
                      "widget": "BBEChart",
                      "voteForUserActionsDisabledWhenLoading": true,
                      "syncWithUserActionsDisabled": true,
                      "showLoadingOverlay": true,
                      "query": "prefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\nprefix imx-ext: <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#>\n\n\nselect distinct?status (count(distinct ?uri) as ?aantal)\nwhere\n{\n  \n   <{{buurt2}}> imx:bevatPerceel/^imx:bevindtZichOpPerceel ?uri.\n    ?uri <http://modellen.geostandaarden.nl/def/imx-geo#status> ?status.\n  filter (?status!=\"bestaand\")\n  filter (?status!=\"Pand in gebruik\")\n    \n    \n}\n  group by ?status\n\n\n \n\n",
                      "panelstyle": "paper2",
                      "gradientColors": true,
                      "enableZoom": false,
                      "stringToColor": true,
                      "defaultMenu": false,
                      "legend": false,
                      "height": "90%",
                      "titleMenubar": "Status pand/bouwwerk",
                      "infoMenubar": "aantallen mbt status zonder \"bestaand\" en \"Pand in gebruik\""
                    }
                  ],
                  "areaSizes": [
                    "50%",
                    "50%"
                  ],
                  "voteForUserActionsDisabledWhenLoading": true,
                  "syncWithUserActionsDisabled": true,
                  "showLoadingOverlay": true
                }
              ],
              "direction": "row",
              "widget": "SplitLayout"
            }
          ],
          "areaSizes": [
            "70px",
            "1"
          ],
          "voteForUserActionsDisabledWhenLoading": true,
          "syncWithUserActionsDisabled": true,
          "showLoadingOverlay": true
        },
        {
          "widget": "BB Component",
          "voteForUserActionsDisabledWhenLoading": true,
          "syncWithUserActionsDisabled": true,
          "showLoadingOverlay": true,
          "url": "https://app.wistor.nl/projects/kadaster/vyzm1"
        },
        {
          "widget": "SplitLayout",
          "direction": "column",
          "areas": [
            {
              "publishVariable": "dmselectie",
              "widget": "BBMap",
              "voteForUserActionsDisabledWhenLoading": true,
              "syncWithUserActionsDisabled": true,
              "showLoadingOverlay": true,
              "panelstyle": "paper2",
              "query": "PREFIX igeo: <http://rdf.insee.fr/def/geo#>\nPREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\nPREFIX im: <http://imgpedia.dcc.uchile.cl/resource/>\nprefix geo: <http://www.opengis.net/ont/geosparql#>\nprefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nprefix imx:<http://modellen.geostandaarden.nl/def/imx-geo#>\nprefix imx-ext: <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#>\n\n\nselect ?uri ?geometry ?color (?color as ?label)\n#baselayer:PDOK grijs;\nwhere\n{\n\n      \n  \n   <https://data.kkg.kadaster.nl/id/buurt/BU03440112/1> imx:bevatPerceel/^imx:bevindtZichOpPerceel ?uri.\n  \n     ?uri imx:registratiegegevens ?reg.\n      filter not exists {?reg <https://modellen.geostandaarden.nl/def/imx-geo#eindGeldigheid> []}\n      \n    bind (strbefore(strafter(str(?uri),\"/id/\"),\"/\")  as ?color2)\n    optional {?uri <https://modellen.kkg.kadaster.nl/def/imxgeo-ext#gebouwType> ?color3}\n    bind (coalesce(?color3,?color2) as ?color)\n # filter (?color!=\"overig\")\n   \n    {?uri imx-ext:maaiveldgeometrie/geo:asWKT ?geometrymv. \n   optional {\n  ?uri imx-ext:bovenaanzichtgeometrie/geo:asWKT ?geometrybo }\n    bind (coalesce (?geometrybo,?geometrymv) as ?geometry)\n  }\n    \n      \n     \n}\n\n\n#title: Gebouwtypes in de Buurt;\n\n \n",
              "titleMenubar": "Stukje IMX-Geo"
            },
            {
              "areaSizes": [
                "70%",
                "30%"
              ],
              "areas": [
                {
                  "titleMenubar": "Datamodel",
                  "extendquery": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n\nPREFIX skos: <http://www.w3.org/2004/02/skos/core#>\n\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n\n\nselect distinct *\n\n\nwhere\n\n{\n\n  \n\n  bind ( <{{uri}}>  as ?node)\n\n    \n\n    optional {?node rdfs:label|skos:prefLabel ?nodeLabel2.}\n\n\n bind (STRBEFORE(STR(?node),\"#\") as ?btext)\n\n bind (IF(?btext=\"\",REPLACE(STR(?node),'([^/]+$)',\"\"),?btext) as ?nodeType)\n\n    bind (IF(BOUND(?nodeLabel2),?nodeLabel2, ?nodeType) as ?nodeLabel)\n\n\n\n    ?node ?edge ?object.\n\n\n  filter (!ISBLANK(?object))\n\n  filter(!ISLITERAL(?object))\n\n\n\nbind (STRBEFORE(STR(?object),\"#\") as ?botext)\n\n bind (IF(?botext=\"\",REPLACE(STR(?object),'([^/]+$)',\"\"),?botext) as ?objectType)\n\n\n   \n\n  bind (REPLACE(REPLACE(REPLACE(REPLACE(STR(?edge),\"http://www.w3.org/2000/01/rdf-schema#\",\"rdfs:\"),\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\",\"rdf:\"),\"http://www.w3.org/2004/02/skos/core#\",\"skos:\"),\"http://www.rws.nl/abdl#\",\"abdl:\") as ?edgeLabel)\n\n    optional {?object rdfs:label|skos:prefLabel ?olabel. } \n\n    bind (if (BOUND(?olabel),?olabel, ?object) as ?objectLabel2)\n\n\n bind (REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(STR(?objectLabel2),\"http://www.w3.org/2000/01/rdf-schema#\",\"rdfs:\"),\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\",\"rdf:\"),\"http://www.w3.org/2004/02/skos/core#\",\"skos:\"),\"http://www.rws.nl/abdl#\",\"abdl:\"),\"https://bimloket.nl/data/kernmodel/thesaurus#\",\"cbnl:\") as ?objectLabel)\n\n\n\n\n}\n    \n    limit 40\n\n",
                  "publishVariable": "bolsel",
                  "subscribeVariable": "",
                  "legend": true,
                  "edgelabels": true,
                  "useLocalNames": true,
                  "query": "PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n\nPREFIX skos: <http://www.w3.org/2004/02/skos/core#>\n\nPREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n\n\nselect distinct *\n\n\nwhere\n\n{\n\n  \n\n  bind ( <{{dmselectie}}>  as ?node)\n\n    \n\n    optional {?node rdfs:label|skos:prefLabel ?nodeLabel2.}\n\n\n bind (STRBEFORE(STR(?node),\"#\") as ?btext)\n\n bind (IF(?btext=\"\",REPLACE(STR(?node),'([^/]+$)',\"\"),?btext) as ?nodeType)\n\n    bind (IF(BOUND(?nodeLabel2),?nodeLabel2, ?nodeType) as ?nodeLabel)\n\n\n\n    ?node ?edge ?object.\n\n\n  filter (!ISBLANK(?object))\n\n  filter(!ISLITERAL(?object))\n\n\n\nbind (STRBEFORE(STR(?object),\"#\") as ?botext)\n\n bind (IF(?botext=\"\",REPLACE(STR(?object),'([^/]+$)',\"\"),?botext) as ?objectType)\n\n\n   \n\n  bind (REPLACE(REPLACE(REPLACE(REPLACE(STR(?edge),\"http://www.w3.org/2000/01/rdf-schema#\",\"rdfs:\"),\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\",\"rdf:\"),\"http://www.w3.org/2004/02/skos/core#\",\"skos:\"),\"http://www.rws.nl/abdl#\",\"abdl:\") as ?edgeLabel)\n\n    optional {?object rdfs:label|skos:prefLabel ?olabel. } \n\n    bind (if (BOUND(?olabel),?olabel, ?object) as ?objectLabel2)\n\n\n bind (REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(STR(?objectLabel2),\"http://www.w3.org/2000/01/rdf-schema#\",\"rdfs:\"),\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\",\"rdf:\"),\"http://www.w3.org/2004/02/skos/core#\",\"skos:\"),\"http://www.rws.nl/abdl#\",\"abdl:\"),\"https://bimloket.nl/data/kernmodel/thesaurus#\",\"cbnl:\") as ?objectLabel)\n\n\n\n\n}\n    \n    limit 40\n\n",
                  "widget": "BBVis",
                  "voteForUserActionsDisabledWhenLoading": true,
                  "syncWithUserActionsDisabled": true,
                  "showLoadingOverlay": true,
                  "panelstyle": "paper2"
                },
                {
                  "query": "PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nselect distinct ?property ?value where\n{\n  {\n    bind ( <{{bolsel}}> as ?value)\n      bind (\"IRI\" as ?property)\n  }\n  union\n  {\n \n  <{{bolsel}}> ?pred ?value.\n#  bind (isLiteral(?pred) as ?literal)\n#  filter (isLiteral(?pred))\n  bind (strafter(str(?pred),\"#\") as ?property)\n  }\n  \n}\n      limit 100",
                  "panelstyle": "paper2",
                  "showLoadingOverlay": true,
                  "syncWithUserActionsDisabled": true,
                  "voteForUserActionsDisabledWhenLoading": true,
                  "widget": "BBPropertyPanel",
                  "titleMenubar": "Kenmerk"
                }
              ],
              "direction": "row",
              "widget": "SplitLayout"
            }
          ],
          "areaSizes": [
            "40%",
            "60%"
          ]
        },
        {
          "query": "select *\nwhere\n{\n  <{{provincie}}> ?a ?b\n}\n  limit 10",
          "widget": "BBTable",
          "voteForUserActionsDisabledWhenLoading": true,
          "syncWithUserActionsDisabled": true,
          "showLoadingOverlay": true,
          "panelstyle": "paper2"
        }
      ],
      "widget": "BBSideMenu",
      "tabs": [
        "IMX-Geo",
        "Sloop vergunningen",
        "Publiekrechtelijke beperking",
        " Datamodel"
      ],
      "voteForUserActionsDisabledWhenLoading": true,
      "syncWithUserActionsDisabled": true,
      "showLoadingOverlay": true,
      "icons": [
        "map",
        "hammer",
        "gavel",
        "info"
      ]
    },
    "bbsparqlendpoint": "",
    "repoURL": "https://api.labs.kadaster.nl/datasets/kadaster/kkg/services/kkg/sparql",
    "logoURL": "https://storage.googleapis.com/exenzo-jobboard/nieuweoogst/public/upload/kadaster.jpg",
    "sparqlErrorMessage": "\"errors connecting to the server\"",
    "css": "{\"height\":\"100%\"}",
    "pageWidth": "99%",
    "parameterValues": "{\"imgeo\":\"http://www.buildingbits.nl/coins2/draft/IMGEO.rdf\",\"keuze\":\"buurt\",\"keuze2\":\"buurt\"}",
    "public": true,
    "layoutName": "ORIGINAL",
    "triggers": [
      {
        "id": "5e9c56ec-df15-4cfe-990e-e3f838ba314a",
        "label": "selection",
        "sparqlQuery": "select ?selection\nwhere\n{\n\n  bind (<{{pb}}> as ?selection)\n}",
        "voteForUserActionsDisabledWhenLoading": false,
        "_id": "67c08937fb6b45002642d767"
      }
    ],
    "prejs": "document.withCredentials=false; //https://api.labs.kadaster.nl/datasets/kadaster/kkg/sparql https://api.labs.kadaster.nl/datasets/kadaster/kkg/services/kkg/sparql",
    "pushURLVariables": [],
    "updateURLVariables": [],
    "layout": {
      "showFooter": true
    }
  }
}
